import(/* webpackMode: "eager", webpackExports: ["ContactTabForm"] */ "/home/pi/prod/strawman/apps/web/app/(landing)/lets-talk/components/ContactTabForm.tsx");
;
import(/* webpackMode: "eager" */ "/home/pi/prod/strawman/apps/web/app/(landing)/lets-talk/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["BrandsList"] */ "/home/pi/prod/strawman/apps/web/components/Brands/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/pi/prod/strawman/node_modules/.pnpm/next@15.4.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/pi/prod/strawman/node_modules/.pnpm/next@15.4.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/pi/prod/strawman/node_modules/.pnpm/next@15.4.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/script.js");
